const assignedCardAccoutns = state => state.assignedAccounts
const assignedCardPaymentInfo = state => state.paymentInfo
const status = state => state.status
export default {
    assignedCardAccoutns,
    assignedCardPaymentInfo,
    status
}
